import { keysToCamelFromSnake } from '../utils/caseconverters';
import { httpGetWithCsrfToken } from '../utils/Http';

export async function getHybridActivityRows(dataset) {
    // Every point at once — the map frames and filters the full extent, and a
    // partial first page would frame the wrong thing.
    const url = `/wt/fenix/graphs/data/${dataset}/?fetch_all=true`;
    const res = await httpGetWithCsrfToken(url);

    if (!res.ok) {
        throw new Error(`Hybrid activity fetch failed: ${res.status}`);
    }

    const data = keysToCamelFromSnake(await res.json(), false);

    if (!Array.isArray(data?.items)) {
        throw new Error('Hybrid activity response has no items array');
    }

    return data.items;
}

export async function getHybridActivityUpdatedAt(dataset) {
    const res = await httpGetWithCsrfToken(
        `/wt/fenix/graphs/metadata/${dataset}/`
    );

    if (!res.ok) {
        throw new Error(`Hybrid activity metadata fetch failed: ${res.status}`);
    }

    const data = await res.json();

    return data?.updated_at ?? null;
}
